// Types

export const VMenuSymbol = Symbol.for('vuetify:v-menu');
//# sourceMappingURL=shared.js.map